<!--
frontend-author:bhavya, vaishnavi,
backend-author: ,
page-name : payment.vue,
page-description : payment create for invoice,
started at : 22-Jun-2019,
edited at : 22-Jun-2019
-->
<template>
  <div class="payments" style="margin-top:-10px;">
    <!--  heading block -->
    <!-- page title for payment create -->
    <GlobalHeader title="Receive Payment" @redirectPage="redirectPage"></GlobalHeader>
    <!-- Validation for records -->
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
            <p class="fw-semi-bold">{{ message }}</p>
          </b-alert>

          <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
            <button type="button" @click="error_show= !error_show" class="close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div
              v-for="item in errors.items"
              :key="item.id"
              v-if="item.scope=='payment-receive-form'"
            >
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-form
      @submit.prevent="onSubmit('payment-receive-form')"
      id="customer_form"
      data-vv-scope="payment-receive-form"
      class="mt-1"
      style="margin-left:3px;margin-right:3px;"
    >
      <div class="sales-bg pt-30p pb-4 mb-2 border-bottom-dot" style="background:#f7f7f7">
        <!--  customer input block -->
        <b-row>
          <b-col xl="10" lg="9" md="9" sm="12" xs="12" @click="removecustomer" class="pr-1">
            <b-form-group>
              <div class="input-group">
                <vue-bootstrap-typeahead
                  v-if="page == 'create'"
                  id="customer_search"
                  class="customer_search"
                  :data="customers"
                  :serializer="customer => customer.label"
                  placeholder="Type to search customer"
                  ref="cus_name_typeahead"
                  @hit="checkpos($event)"
                  v-model="cus_id"
                  title="Enter first three characters of customer to search"
                />
                <input
                  v-else
                  type="text"
                  class="form-control input_customer_search"
                  v-model="cus_id"
                  readonly
                />
                <div class="input-group-append">
                  <b-dropdown
                    class="advance-search-option btn-radius-unset text-center"
                    size="sm"
                    variant="light"
                    :text="search_value"
                    style="height:32px;"
                  >
                    <b-dropdown-item
                      @click="search_column = 'cus_display_name',search_value='Customer Name'"
                    >Customer Name</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_ph_no_1',search_value='Phone Number'"
                    >Phone Number</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_legacy_id',search_value='Customer ID'"
                    >Customer ID</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_gst_no',search_value='Gst Number'"
                    >Gst Number</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_pan_no',search_value='PAN Number'"
                    >PAN Number</b-dropdown-item>
                  </b-dropdown>
                  <input :type="'hidden'" name="cus_id" class="form-control" v-model="field.cus_id" />
                </div>
                <template v-if="field.cus_id != ''">
                  <span
                    class="ml-2 mt-2 mr-1 cursor_pointer"
                    v-b-tooltip
                    title="View Customer Details"
                    @click="toggleCustomerDetails()"
                  >
                    <i class="la la-external-link la-lg"></i>
                  </span>
                  <span class="pl-1 mt-2 cursor_pointer">
                    <b-badge variant="success" size="xs">{{field.currency_code}}</b-badge>
                  </span>
                </template>
              </div>
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="3" sm="12" xs="12" class="text-right pl-0">
            <h3 style="margin-bottom:0px"></h3>
          </b-col>
        </b-row>
      </div>
      <div :class="{'form-mask': check_for_customer}">
        <b-row style="max-width:1000px" class="mt-4">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              :label="'Payment'"
              label-class="required"
              label-for="Payment-code"
              class="mb-3"
              v-if="pymnt_settings_details.pymt_code_field"
            >
              <b-input-group class="vselect-custom-add">
                <template slot="append">
                  <b-input-group-text
                    class="vselect-custom-add-icon"
                    v-b-tooltip
                    title="Customize auto generate code"
                    style="margin-left:2px"
                    v-on:click="$root.$emit('bv::show::modal', 'addautogeneratecode')"
                  >
                    <i class="la la-cog"></i>
                  </b-input-group-text>
                </template>
                <template slot="prepend">
                  <b-form-input
                    style="border-top-right-radius:0 !important;border-bottom-right-radius:0 !important"
                    type="text"
                    size="sm"
                    name="Payment"
                    v-model.trim="field.pymnt_no"
                    data-vv-name="payment no"
                    v-validate="'required|max:16'"
                  />
                </template>
              </b-input-group>
            </b-form-group>
            <b-form-group
              label-class="required"
              label="Payment Mode"
              label-for="Payment mode"
              class="mb-3"
            >
              <v-select
                :clearable="false"
                id="payment-method-select"
                v-validate="'required'"
                data-vv-name="payment method"
                name="pymnt_mthd"
                v-model.trim="field.pymnt_mthd"
                size="sm"
                index="value"
                label="label"
                :options="details.paymentmethod"
              />
            </b-form-group>
            <b-form-group
              label-class="required"
              label="Amount received"
              label-for="Amount_received"
              class="mb-3 pt-2"
            >
              <b-input-group
                :prepend="getDetails($AppDetails.currency_details,field.cus_currency,'currency_code')"
                class="mb-2 mr-sm-2 mb-sm-0 payment_currency"
              >
                <input
                  :disabled="page == 'update' && list.data.header_details.pymnt_type == 2 ? true : false"
                  id="check-amount-tally"
                  type="text"
                  @blur="disableByRef(),headerRoundOff('received_amount',field.received_amount);field.received_amount>0?tooltip=1:0"
                  @change="set_received_price= ''"
                  size="sm"
                  name="received_amount"
                  data-vv-name="received amount"
                  v-validate="'max:14|required|excluded:'+parseFloat(0).toFixed(2)"
                  :class="{'unselectable':unselectable_received_amount,'form-control':true}"
                  v-model.trim="field.received_amount"
                />
              </b-input-group>
              <span class="pl-2 mt-2 mr-0">
                <b-form-checkbox
                  class="mr-0 d-block"
                  v-if="page == 'create'"
                  name="is_tax_reverse_charge"
                  value="1"
                  unchecked-value="0"
                  @change="field.received_amount = field.full == 0 ? total.total_due_amount : '0.00', unselectable_received_amount = field.full == 0 ? true : false,amount_equalizing()"
                  v-model.trim="field.full"
                >{{ 'Pay full amount' + '('+total.total_due_amount+')' }}</b-form-checkbox>
              </span>
              <div
                class="tooltip"
                role="tooltip"
                v-if="page == 'create'&&tooltip==1"
                v-on:hide="tooltiphide($event)"
                :show="show"
                ref="tooltip"
                target="check-amount-tally"
              >
                <div class="arrow"></div>
                <div
                  class="tooltip-inner"
                  style="background-color:#fff !important;color:#000 !important;border:1px solid #e4dcdc !important"
                >
                  Would you like this
                  <br />amount to be reflected in
                  <br />payment field ?
                  <br />
                  <b-button
                    variant="success"
                    size="sm"
                    class="m-2"
                    @click="amount_equalizing(),set_received_price = 1;tooltip=0"
                  >Yes</b-button>
                  <b-button variant="default" size="sm" @click="set_received_price = 0;tooltip=0">No</b-button>
                </div>
              </div>
              <!-- <b-tooltip
                    v-if="page == 'create'"
                    v-on:hide="tooltiphide($event)"
                    :show="show"
                    :disabled.sync="tooltip_disable"
                    ref="tooltip"
                    target="check-amount-tally"
                    style="background-color: #fff"
                  >
                    Would you like this
                    <br />amount to be reflected in
                    <br />payment field ?
                    <br />
                    <b-button
                      variant="success"
                      size="sm"
                      class="m-2"
                      @click="amount_equalizing(),set_received_price = 1"
                    >Yes</b-button>
                    <b-button variant="default" size="sm" @click="set_received_price = 0">No</b-button>
              </b-tooltip>-->
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              label="Deposit To"
              label-for="Deposit To"
              label-class="required"
              class="mb-3"
            >
              <select
                v-model.trim="field.deposit_mthd"
                v-chosen="field.deposit_mthd"
                name="Deposit To"
                data-vv-name="Deposit To"
                v-validate="'required'"
                class="chosen v-select form-control"
              >
                <template v-for="(item,index) in  details.accounts.parent_accounts">
                  <optgroup :label="item.gl_acc_type" :key="index">
                     <template
                      v-if="
                        details.accounts.child_accounts[item.gl_acc_type_id]
                          .length != 0
                      "
                    >
                    <option
                    v-if="
                     (item.gl_acc_type_id!=6&&item.gl_acc_type_id!=21&& child.is_active == 1) ||
                      field.deposit_mthd == child.gl_acc_id||((item.gl_acc_type_id==6||item.gl_acc_type_id==21)&&(child.currency==field.cus_currency||child.currency==org_currency_id))
                    "
                      v-for="child in details.accounts.child_accounts[item.gl_acc_type_id]"
                      :key="child.id"
                      :value="child.gl_acc_id"
                    >
                    {{(item.gl_acc_type_id==6||item.gl_acc_type_id==21)&&child.bank_code?'['+child.bank_code+'] ':''}}{{ child.gl_acc_name }}
                    </option>
                  </template>
                  </optgroup>
                </template>
              </select>
            </b-form-group>
            <b-form-group
              label-class="required"
              label="Payment date"
              label-for="Payment Date"
              class="mb-3"
            >
              <DatePicker
                placeholder=" "
                :format="$AppDetails.organization.date_format"
                input-name="pymnt_date"
                lang="en"
                input-class="form-control"
                @change="selectDate"
                style="width:100% !important;"
                name="pymnt_date"
                data-vv-name="payment date"
                v-validate="'required'"
                v-model.trim="field.pymnt_date"
              >
                <i class="fa fa-calendar text-dark" slot="calendar-icon" />
              </DatePicker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
              v-b-toggle.other-details
            >
              Other details
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="other-details" visible>
          <b-row style="max-width:1000px;">
            <b-col cols="12" lg="5" md="6" sm="8">
              <b-form-group label="Transaction No." label-for="Transaction" class="mb-3">
                <b-form-input
                  type="text"
                  size="sm"
                  name="tns_no"
                  data-vv-name="transaction no"
                  v-model.trim="field.tns_no"
                  v-validate="'max:20'"
                />
              </b-form-group>
              <b-form-group label="Bank Charges(If any)" label-for="bank_charges" class="mb-3">
                <input
                  class="form-control"
                  @blur="headerRoundOff('bank_charges',field.bank_charges)"
                  type="text"
                  size="sm"
                  data-vv-name="bank charges"
                  v-validate="'required|decimal:2|max_value:'+field.received_amount"
                  name="bank_charges"
                  v-model.trim="field.bank_charges"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="5" md="6" sm="8">
              <b-form-group label="Reference No." label-for="ref_no" class="mb-3">
                <b-form-input
                  type="text"
                  size="sm"
                  name="ref_no"
                  v-model.trim="field.ref_no"
                  v-validate="'max:30'"
                  data-vv-name="reference no"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row style="max-width:1000px;" class="mt-3">
            <b-col cols="12">
              <b-form-group
                horizontal
                label="Tax Deducted?"
                label-for="tax_deducted"
                :label-cols="2"
                class="mb-3"
              >
                <b-form-radio-group
                  id="filter_status"
                  class="mt-2"
                  v-model="field.is_tax_deducted"
                  @input="withheldvalue()"
                  :options="tax_deducted"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if=" field.is_tax_deducted == 1">
            <b-col cols="12" lg="5" md="6" sm="8">
              <b-form-group
                label-class="required"
                label="TDS Tax Account"
                class="mb-3"
                label-for="Payment mode"
              >
                <v-select
                  :clearable="false"
                  id="tds-account-select"
                  v-validate="'required'"
                  data-vv-name="TDS tax accouont"
                  name="tds_tax_account"
                  v-model.trim="field.tds_tax_account"
                  size="sm"
                  index="gl_acc_id"
                  label="gl_acc_name"
                  :options="details.tds_acc_types"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>

        <template v-if="pymnt_settings_details.custom_field.length > 0">
          <b-row style="max-width:1000px" class="my-4">
            <b-col>
              <h6
                class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
                v-b-toggle.collapse-1
              >
                Custom fields
                <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
              </h6>
            </b-col>
          </b-row>

          <b-collapse id="collapse-1" visible>
            <b-row style="max-width:1000px;">
              <b-col
                cols="12"
                lg="5"
                md="6"
                sm="8"
                :key="index"
                v-for="(custom_field,index) in pymnt_settings_details.custom_field"
                v-if="custom_field.status == 1 && custom_field.permissions == 'write'"
              >
                <CustomPreview
                  v-on:assigncustomvalue="assigncustomvalue($event)"
                  :custom="custom_field"
                  :disabled="false"
                  :modelname="field[custom_field.field_name]"
                />
                <input
                  type="hidden"
                  :name="custom_field.label_name"
                  :data-vv-name="custom_field.label_name"
                  v-validate="custom_field.validation"
                  v-model="field[custom_field.field_name]"
                />
              </b-col>
            </b-row>
          </b-collapse>
        </template>

        <!-- item table -->
        <div class="mt-5" style="max-width:1345px;display:flow-root">
          <b-row style="max-width:1400px;" class="mb-1">
            <b-col lg="6" xl="6" md="6" sm="6" xs="6">
              <h5>Unpaid Invoices</h5>
            </b-col>
            <b-col lg="6" xl="6" md="6" sm="6" xs="6">
              <span v-if="field.is_export == 2" class="float-right display-flex fw-semi-bold mr-2">
                <span
                  v-if=" currency_details.exchange_rate_date!=''||org_details.exchange_rate_status==0"
                >
                  <small
                    v-if="changed_currency==false"
                    class="d-block"
                  >Exchange rate as on creation,</small>
                  <small
                    v-else
                    class="d-block"
                  >As of Date: {{currency_details.exchange_rate_date!=''?getDateFormat(currency_details.exchange_rate_date):getDateFormat(field.pymnt_date)}}</small>
                  <span class="float-right" style="font-size:11px;">
                    1 {{field.currency_code}} = {{parseFloat(field.unit_currency_value)}} {{orgCurrency}}
                    <span>
                      <b-dropdown
                        class="exchange-dropdown"
                        right
                        toggle-class="p-0 "
                        variant="link"
                        no-caret
                        size="xs"
                        ref="exchange_rate_dropdown"
                      >
                        <template slot="button-content">
                          <i
                            class="la la-edit la-lg theme-text-color pl-1"
                            style="top:-3px;position:relative"
                            @click="exchange_rate_details={ currency_exchange_rate: field.unit_currency_value , save_exchange_rate: 0, recalc: 0 }"
                          ></i>
                        </template>
                        <b-dropdown-header>Edit Exchange Rate</b-dropdown-header>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-form class="p-3" style="width:250px;">
                          <b-row>
                            <b-col>
                              <b-form-group
                                :label="'Exchange Rate(in '+orgCurrency+')'"
                                label-class="required"
                                label-for="ex-rate"
                              >
                                <b-input
                                  style="width:130px"
                                  @blur="exchange_rate_details.currency_exchange_rate = exchange_rate_details.currency_exchange_rate==''||parseFloat(exchange_rate_details.currency_exchange_rate) <=  0||parseFloat(exchange_rate_details.currency_exchange_rate) >  100000000000000||isNaN(parseFloat(exchange_rate_details.currency_exchange_rate))? 1 : parseFloat(exchange_rate_details.currency_exchange_rate)"
                                  v-model="exchange_rate_details.currency_exchange_rate"
                                ></b-input>
                              </b-form-group>
                              <b-checkbox
                                v-if="org_details.exchange_rate_status==1&&page=='create'"
                                unchecked-value="0"
                                value="1"
                                v-model="exchange_rate_details.save_exchange_rate"
                                class="mt-2"
                              >
                                <small>Set this rate as default for {{getDateFormat(field.pymnt_date)}}</small>
                              </b-checkbox>
                            </b-col>
                          </b-row>
                          <b-row class="mt-3">
                            <b-col>
                              <b-button
                                variant="primary"
                                size="xs"
                                @click="exchangeRateSubmit()"
                              >Save</b-button>
                            </b-col>
                          </b-row>
                        </b-dropdown-form>
                      </b-dropdown>
                    </span>
                  </span>
                </span>
                <template v-else>
                  <b-form-group
                    label="Exchange rate"
                    label-class="required"
                    label-cols="4"
                    label-for="currency"
                  >
                    <b-input-group
                      size="sm"
                      :append="orgCurrency"
                      :prepend="'1 '+getDetails(
                    this.$AppDetails.currency_details,
                    field.cus_currency,
                    'currency_code'
                    ) +' = '"
                    >
                      <b-form-input
                        @blur="changeExchangeRate()"
                        type="text"
                        class="text-right"
                        v-model.trim="field.unit_currency_value"
                        name="Currency"
                        data-vv-name="currency"
                        v-validate="'required|decimal:5|excluded:'+parseFloat(0).toFixed(2)+'|min_value:0'"
                      ></b-form-input>
                    </b-input-group>
                    <small class="text-muted">This will be set as the exchange rate for this date.</small>
                  </b-form-group>
                </template>
              </span>
              <span
                class="theme-text-color mr-3"
                style="float:right;cursor:pointer"
                @click="clearAppliedInvoice"
              >Clear Applied Amount</span>
            </b-col>
          </b-row>
        </div>

        <div class="mt-1">
          <b-row style="max-width:1400px;">
            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
              <table
                :class="items.length>0?'table table-bordered sales-table last-child-border-none':'table table-bordered '"
              >
                <thead>
                  <!-- <th width="1%">#</th> -->
                  <th width="25%">Date</th>
                  <th class="text-right" width="15%">Invoice NO.</th>
                  <th width="15%" class="text-right">Amount</th>
                  <th width="15%" class="text-right">due</th>
                  <th v-if="field.is_tax_deducted=='1'" class="text-right">Withholding tax</th>
                  <th width="15%" class="text-right">Payment</th>
                  <th width="1%" v-if="items.length>0"></th>
                </thead>
                <tbody v-if="items.length>0">
                  <tr v-for="(item,index) in items" :key="index">
                    <!-- <td>{{ index + 1 }}</td> -->
                    <td>
                      {{getDateFormat(new Date(item.created_date))}}
                      <br />
                      <!-- due date -->
                      <span style="font-size:11px;">
                        <b>Due date :</b>
                        {{getDateFormat(new Date(item.due_date))}}
                      </span>
                    </td>
                    <td class="text-right">
                      <!--   inv number -->
                      {{item.label}}
                      <!--   inv amount -->
                    </td>
                    <td
                      class="text-right"
                    >{{ parseFloat(item.grand_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <!--   due amount -->
                    <td
                      class="text-right"
                    >{{parseFloat(item.due_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                    <td class="text-right" v-if="field.is_tax_deducted=='1'">
                      <!--  payment  details -->
                      <input
                        class="text-right"
                        type="text"
                        :name="'withheld_amount['+index+']'"
                        @blur="roundOff(index,item.withheld_amount,'withheld_amount')"
                        data-vv-name="Withheld amount"
                        v-validate="'max_value:'+checkforvalidation(index,'paid_amount')"
                        v-model.trim="item.withheld_amount"
                        style="border:none"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('withheld_amount['+index+']')"
                      >The amount entered must be numeric and not more than the balance due for the selected invoices.</span>
                    </td>
                    <td class="text-right">
                      <!--  payment  details -->
                      <input
                        class="text-right"
                        type="text"
                        :name="'paid_amount['+index+']'"
                        @blur="roundOff(index,item.paid_amount,'paid_amount')"
                        data-vv-name="Paid amount"
                        v-validate="'max_value:'+checkforvalidation(index,'withheld_amount')"
                        v-model.trim="item.paid_amount"
                        style="border:none"
                      />
                      <span
                        class="text-danger"
                        v-if="errors.has('paid_amount['+index+']')"
                      >The amount entered must be numeric and not more than the balance due for the selected invoices.</span>
                      <span
                        v-if="page == 'create'"
                        class="text-link d-block"
                        style="cursor:pointer"
                        @click="item.paid_amount = parseFloat(item.due_amount - item.withheld_amount).toFixed(2)"
                      >Pay in full</span>
                    </td>
                    <td>
                      <!--  Trash to remove column -->
                    </td>
                  </tr>
                  <tr>
                    <td class="no-border">
                      <p class="pt-2 mb-1">
                        <small>
                          <i class="la la-exclamation-circle la-lg pr-2"></i>List contains only approved and partially paid invoices
                        </small>
                      </p>
                    </td>
                    <td class="no-border text-right" :colspan="field.is_tax_deducted=='1'?4:3">
                      <p
                        class="fw-bold pt-2 mb-1"
                        v-if="field.is_tax_deducted=='1' "
                      >Total withheld Amount</p>
                    </td>
                    <td class="no-border text-right">
                      <p
                        class="pt-2 mb-1 mr-2"
                        v-if="field.is_tax_deducted=='1' "
                      >{{ currency_symbol +' '+ total.total_withheld_amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="no-border text-right" :colspan="field.is_tax_deducted=='1'?5:4">
                      <p class="fw-bold pt-2 mb-1">Total</p>
                    </td>
                    <td class="no-border text-right">
                      <p class="pt-2 mb-1 mr-2">{{ currency_symbol +' '+ total.total_paid_amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="no-border text-right" :colspan="field.is_tax_deducted=='1'?5:4">
                      <p class="pt-2 mb-1">Amount received</p>
                    </td>
                    <td class="no-border text-right">
                      <p class="pt-2 mb-1 mr-2">{{ currency_symbol +' '+ received_amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="no-border text-right" :colspan="field.is_tax_deducted=='1'?5:4">
                      <p class="pt-2 mb-1">Amount used for payments</p>
                    </td>
                    <td class="no-border text-right">
                      <p class="pt-2 mb-1 mr-2">{{ currency_symbol +' '+ field.used_amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="no-border text-right" :colspan="field.is_tax_deducted=='1'?5:4">
                      <p class="pt-2 mb-1">Amount Refunded</p>
                    </td>
                    <td class="no-border text-right">
                      <p class="pt-2 mb-1 mr-2">{{ currency_symbol +' '+ field.refund_amount }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="no-border text-right" :colspan="field.is_tax_deducted=='1'?5:4">
                      <p class="pt-2 mb-1">
                        <span
                          class="mb-2 mr-2"
                          :class="{'glyphicon glyphicon-warning-sign':errors.has('excess_amount')}"
                        ></span> Amount in excess
                      </p>
                    </td>
                    <td class="no-border text-right">
                      <p class="pt-2 mb-1 mr-2">{{ currency_symbol +' '+ field.excess_amount }}</p>
                      <input
                        type="hidden"
                        data-vv-name="excess form"
                        v-validate="'min_value:0'"
                        v-model.trim="field.excess_amount"
                        name="excess_amount"
                      />
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td
                      colspan="5"
                      class="text-center"
                    >There are no unpaid invoices for this customer that can be applied,that can be applied for this customer</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </div>
        <!--  adding item line details -->

        <b-row style="max-width:1170px;">
          <b-col xl="12" lg="12" md="12" sm="12" xs="12">
            <b-form-group class="mt-1 pb-2">
              <!--  invoice extra notes -->
              <b-row>
                <b-col xl="7" lg="10" md="12" sm="12" xs="12">
                  <label for="datetimepicker">Customer Notes(Internal use. Not visible to customer)</label>
                  <b-form-textarea
                    @input="pymnt_desc_changed=true"
                    name="cus_inv_notes"
                    :rows="4"
                    v-model="field.cus_inv_notes"
                    id="cus_inv_notes"
                    data-vv-name="cus_inv_notes"
                    v-validate="'max:250'"
                  />
                  <b-form-checkbox
                    v-if="pymnt_desc_changed==true"
                    id="pymnt_desc_changed"
                    v-model.trim="field.pymnt_desc_changed"
                    name="pymnt_desc_changed"
                    value="1"
                    unchecked-value="0"
                  >Use this in future.</b-form-checkbox>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- footer block -->
        <div class="footer" v-if="page == 'create'">
          <div :class="{'form-action' : true}">
            <b-button
              type="submit"
              variant="primary"
              class="btn-rounded mr-3"
              :disabled="submitted"
            >
              <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
            </b-button>
          </div>
        </div>
        <div class="footer" v-if="page == 'update'">
          <div :class="{'form-action' : true}">
            <b-button
              type="submit"
              variant="primary"
              class="btn-rounded mr-3"
              :disabled="submitted"
            >
              <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Update
            </b-button>
          </div>
        </div>
      </div>
    </b-form>

    <AutoGenerateCode v-on:setCodeValue="getCodeValue($event)" :type="field.type||'payment_received'"></AutoGenerateCode>
    <ShowCustomerDetails v-if="customer_details == 1"></ShowCustomerDetails>
    <!-- Modal for change exchange rate value change warning message -->
    <ExchangeRateWarning></ExchangeRateWarning>
    <b-modal
      id="exchangerate"
      name="exchangerate"
      body-class="bg-white"
      title="Payment"
      cancel-title="Close"
      cancel-variant="light"
      @ok="payment=true;onSubmit('payment-receive-form')"
    >Would you like to store the excess amount of as over payment for this customer</b-modal>
  </div>
</template>
<script scoped>
// import all the components, files and funciton
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import getPageTitle from "@/utils/get-page-title"; // to set page title
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import VueBootstrapTypeahead from "vue-bootstrap-typeahead"; // data on search api calls
import DatePicker from "vue2-datepicker"; // vue datepicker
import vSelect from "vue-select"; // searchable select dropdown
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import $ from "jquery"; // to do jquery function

import AutoGenerateCode from "@/components/Modal/AutoGenerateCode";
import ShowCustomerDetails from "@/components/Form/Customer/ShowCustomerDetails";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import ExchangeRateWarning from "@/components/Modal/ExchangeRateWarning"; //for Exchange rate change warning message in modal

export default {
  props: ["page", "duplicatecode", "submitted"],
  mixins: [formatDate],
  name: "Payment", // page name
  components: {
    VueBootstrapTypeahead, //on change api
    CustomPreview,
    DatePicker, //datepicker
    vSelect, //vue select
    AutoGenerateCode,
    ShowCustomerDetails,
    ExchangeRateWarning //modal component for exchange rate changes
  },
  data() {
    return {
      tooltip: 0,
      payCollapse: "",
      payment: false,
      tax_deducted: [
        // radio button for taxable preferance
        {
          text: "No Tax deducted",
          value: "0"
        },
        {
          text: "Yes, TDS (Income Tax)",
          value: "1"
        }
      ],
      currency_symbol: "",
      customer_details: 0,
      search_value: "Customer Name",
      search_column: "cus_display_name",
      unselectable_received_amount: false, // make the received amount selectable
      cus_id: "",
      tooltip_disable: true,
      show: false,
      check_for_customer: true,
      customers: [], //store the details of customers

      error_show: false, // to show the error message
      field: this.createFreshEventObject(), //header detail data initialize
      update_price: false, // check for updation
      set_received_price: "",
      //items detail data
      items: [
        {
          created_date: "",
          label: "",
          due_amount: "0.00",
          withheld_amount: "0.00",
          due_date: "",
          paid_amount: "0.00",
          grand_total: "0.00"
        }
      ],
      old_cus_id: "",
      old_currency_code: "",

      changed_currency: true,
      exchange_rate_details: {
        currency_exchange_rate: 1,
        save_exchange_rate: 0,
        recalc: 0
      }
    };
  },
  methods: {
       redirectPage(){
              if(this.$route.query.customer_id){
                this.$router.push({name:'CustomerView',params:{id:this.$route.query.customer_id}})
              }
                else if(this.$route.query.inv_id){
                this.$router.push({name:'InvoiceView',params:{id:this.$route.query.inv_id}})
              }
                else if(this.$route.query.page_from=='view'&&(this.$route.params.id||this.$route.query.old_id)){
              this.$router.push({name:'PaymentView',params:{id:this.$route.params.id||this.$route.query.old_id}})
              } else {
        if (this.$store.state.payment.payment_index_history) {
          this.$router.push(this.$store.state.payment.payment_index_history);
        } else {
          this.$router.push({ name: "Payment" });
        }
      }
    },

    //  assign custom value
    assigncustomvalue(ev) {
      this.field[ev.field] = ev.value;
    },
    withheldvalue() {
      var i;
      for (i = 0; i < this.items.length; i++) {
        if (this.field.is_tax_deducted == 0) {
          this.items[i].withheld_amount = parseFloat(0);
        }
      }
    },
    //  update code details
    getCodeValue(ev) {
      this.field.code_id = ev.code_id;
      this.field.suffix = ev.suffix;
      this.field.prefix = ev.prefix;
      this.field.pymnt_no = ev.prefix + ev.suffix;
    },
    checkforvalidation(index, field) {
      var pymnt_amt = this.items[index][field];
      var due_amt = this.items[index]["due_amount"];
      pymnt_amt =
        typeof pymnt_amt != undefined && !isNaN(pymnt_amt) && pymnt_amt != ""
          ? parseFloat(pymnt_amt).toFixed(2)
          : parseFloat(0).toFixed(2);
      due_amt =
        typeof due_amt != undefined && !isNaN(due_amt) && due_amt != ""
          ? parseFloat(due_amt).toFixed(2)
          : parseFloat(0).toFixed(2);
      return parseFloat(due_amt) - parseFloat(pymnt_amt);
    },
    //Customer details
    async toggleCustomerDetails() {
      await this.$store
          .dispatch("customer/fetchViewList", this.field.cus_id).then(response=>{
            if(response.data.code!=200){
              this.customer_details = 0;
              window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: response.data.status,
              type: response.data.type,
              showCloseButton: true,
            });
            }else{
              this.customer_details = 1;
            }
          })
          if(this.customer_details == 1){
            await EventBus.$emit("toggleCustomerDetails");
          }

    },
    amount_equalizing() {
      // get the received amount
      var received_amount = parseFloat(this.field.received_amount);
      // loop through each amount
      $.each(this.items, function(key, value) {
        //  assign the value for paid amount in itme table
        if (received_amount >= parseFloat(value.due_amount)) {
          value.paid_amount = parseFloat(value.due_amount).toFixed(2);
          received_amount = received_amount - parseFloat(value.due_amount);
        } else {
          //  if received amount not have enough money to tally the paid amount break the foreach
          value.paid_amount = received_amount.toFixed(2);
          received_amount = parseFloat(0);
          // return false;
        }
      });
    },
    // hide after setting boolean expression for set received price
    tooltiphide(e) {
      if (this.set_received_price == "1" || this.set_received_price == "0") {
        this.tooltip_disable = true;
        this.show = false;
      } else {
        e.preventDefault();
      }
    },
    // option for disabling and enabling the tool tip
    disableByRef() {
      if (this.set_received_price == "") {
        this.tooltip_disable = false;
        this.show = true;
      } else {
        this.tooltip_disable = true;
        this.show = false;
      }
    },
    // clear applied invoice
    clearAppliedInvoice() {
      var i;
      for (i = 0; i < this.items.length; i++) {
        this.items[i].paid_amount = parseFloat(0).toFixed(2);
      }
    },
    //round off for received amout
    headerRoundOff(field, val) {
      this.field[field] =
        typeof val != undefined && !isNaN(val) && val != ""
          ? parseFloat(val).toFixed(2)
          : parseFloat(0).toFixed(2);
    },
    //  round off line item amount to two deximal values
    roundOff(index, val, field) {
      this.items[index][field] =
        typeof val != undefined && !isNaN(val) && val != ""
          ? parseFloat(val).toFixed(2)
          : parseFloat(0).toFixed(2);
    },
    //  remove the design of removed customer
    removecustomer(e) {
      this.customer_invoice_details = [];
      if (e.target.matches(".remover")) {
        this.customer_details = 0;
        $("#customer_search input").removeClass("mask");
        $("#customer_search .input-group .remover").remove();
        this.$refs.cus_name_typeahead.inputValue = "";
        this.check_for_customer = true;
        this.old_cus_id = this.field.cus_id;
        this.old_currency_code = this.field.currency_code;
        this.old_exchange_rate = this.field.unit_currency_value;
        this.field = this.createFreshEventObject();
        this.items = [
          {
            created_date: "",
            label: "",
            due_amount: "0.00",
            due_date: "",
            paid_amount: "0.00",
            grand_total: "0.00",
            withheld_amount: "0.00"
          }
        ];
      }
    },
    selectDate(val) {
      //  if the payment term in selected customer not empty enter into condition
      this.field.pymnt_date =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
      if (this.changed_currency) {
        this.getExchangeRateValue(1);
      }
    },
    //change exchange rate
    async changeExchangeRate() {
      this.old_exchange_rate = this.field.unit_currency_value;
      this.field.unit_currency_value =
        parseFloat(this.field.unit_currency_value) <= 0 ||
        this.field.unit_currency_value == ""
          ? 1
          : this.field.unit_currency_value;
    },
    // get exchange rate value with transcation date
    getExchangeRateValue(date_change) {
      this.$store
        .dispatch("customer/getCurrencyRate", {
          id: this.field.cus_id,
          currency_id: this.field.cus_currency,
          date: this.field.pymnt_date
        })
        .then(() => {
          this.field.unit_currency_value =
            this.currency_details.currency_exchange_rate != "" &&
            this.currency_details.currency_exchange_rate > 0
              ? this.currency_details.currency_exchange_rate
              : this.currency_details.currency_code == this.orgCurrency
              ? 1
              : this.old_exchange_rate;
          this.field.currency_code = this.currency_details.currency_code;
          if (
            this.old_cus_id != this.field.cus_id &&
            this.old_currency_code != this.field.currency_code
          ) {
            this.changed_currency = true;
            this.old_exchange_rate = this.field.unit_currency_value;
            if (
              this.field.currency_code != this.orgCurrency &&
              this.old_currency_code != ""
            ) {
              if (this.items.some(x => x.pdt_id != "") && date_change != 1) {
                this.$root.$emit("bv::show::modal", "cus_change_exchange_rate");
              }
            }
          } else {
            this.changed_currency = this.page == "update" ? false : true;
          }
        });
    },
    // currency exchange rate dropdown form submit
    exchangeRateSubmit() {
      if (this.exchange_rate_details.save_exchange_rate == 1) {
        var data = {
          currency_id: this.field.cus_currency,
          date: this.field.pymnt_date,
          value: this.exchange_rate_details.currency_exchange_rate,
          code: this.field.currency_code
        };
        data = JSON.stringify(data);
        this.$store.dispatch("currency/addExchangeRate", data).then(() => {
          this.submitted = false;
          if (this.exchange_rate_type == "success") {
            this.error_msg = false;
            //to show the alert message for success or error after api call
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.exchange_rate_message,
              type: this.exchange_rate_type,
              showCloseButton: true
            });
          } else {
            this.error_msg = true;
          }
        });
      }
      this.old_exchange_rate = this.exchange_rate_details.currency_exchange_rate;
      this.field.unit_currency_value = this.exchange_rate_details.currency_exchange_rate;
      // hide dropdown exchange_rate_dropdown
      this.$refs.exchange_rate_dropdown.hide(true);
    },
    //onSubmit process
    onSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          if (
            (this.tooltip != 1 && this.page == "create") ||
            this.page == "update"
          ) {
            if (this.field.used_amount > 0 || this.payment == true) {
              //  send the json data
              var data = JSON.stringify({
                header_details: this.field,
                item_details: this.items
              });
              this.$emit("onSubmit", data);
            } else {
              this.$root.$emit("bv::show::modal", "exchangerate");
            }
          }
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // show validation message
        }
      });

      return false;
    },
    checkpos(event) {
      if (this.update_price == true) {
        //  design for selected customer inpout field
        this.customer_details = 0;
        $("#customer_search input").addClass("mask");
        $("#customer_search .input-group").append(
          "<span class='la la-close p-2 mt-1 remover'></span>"
        );
        this.field.cus_id = event.value; // assgin the selected customer id to cus id modal
        if (event.currency != this.$AppDetails.organization.org_currency) {
          this.field.is_export = 2;
          this.field.place_of_supply = {
            label: this.getDetails(
              this.$AppDetails.state_details,
              "97",
              "state_name"
            ),
            value: 97
          };
        } else {
          this.field.is_export = 1;
          this.field.place_of_supply = {
            label: this.getDetails(
              this.$AppDetails.state_details,
              event.pos,
              "state_name"
            ),
            value: event.pos
          };
        }
        this.field.cus_currency = event.currency;
        // get the place of supply of selected cusotmer
        var cus_state =
          typeof this.field.cus_id != "undefined" &&
          this.field.cus_id != "" &&
          event != null
            ? this.field.cus_id
            : "";
        // enter if pos not empty
        if (cus_state != "") {
          //  check the invoice details of seleced customer
          var data = JSON.stringify({
            id: cus_state,
            page: "payment"
          });
          this.$store
            .dispatch("general/fetchCustomerInvoiceDetails", data)
            .then(() => {
              this.items = this.customer_invoice_details;
              //  remove mask from form
              this.check_for_customer = false;
            });
        }
        //  to update currency symbol
        this.currency_symbol = this.getDetails(
          this.$AppDetails.currency_details,
          this.field.cus_currency || this.$AppDetails.organization.org_currency,
          "currency_symbol"
        );
        this.getExchangeRateValue(0);
        if(this.details.primary_acc.gl_acc_id!=''&&this.details.primary_acc.currency==this.field.cus_currency){
        this.field.deposit_mthd=this.details.primary_acc.gl_acc_id
        }else{
          this.field.deposit_mthd="46"
        }
      }
    },
    updateFields() {
      if (this.page == "update") {
        this.changed_currency = false;
        this.field = this.list.data.header_details;
        this.field.exchange_rate_status = this.org_details.exchange_rate_status;
        this.old_cus_id = this.field.cus_id;
        this.old_currency_code = this.field.currency_code;
        this.old_exchange_rate = this.field.unit_currency_value;
        this.field.pymnt_desc_changed = 0;
        // this.field.full = 0;
        // this.items = this.list.data.item_details;
        var inv_item_payment_details = {};
        var inv_ids = [];
        var i;
        for (i = 0; i < this.list.data.item_details.length; i++) {
          inv_item_payment_details[
            this.list.data.item_details[i].inv_hdr_id
          ] = {
            pymnt_applied_amount: this.list.data.item_details[i]
              .pymnt_applied_amount,
            withheld_amount: this.list.data.item_details[i].withheld_amount
          };
          inv_ids.push(this.list.data.item_details[i].inv_hdr_id);
        }
        // var tds_tax_account_selected = this.list.field.tds_tax_account;
        inv_ids = inv_ids.join(",");
        //  check the invoice details of seleced customer
        var data = JSON.stringify({
          id: this.list.data.header_details.cus_id,
          page: "payment",
          inv_ids: inv_ids
        });
        this.$store
          .dispatch("general/fetchCustomerInvoiceDetails", data)
          .then(() => {
            this.items = this.customer_invoice_details;
            this.items.forEach(function(element) {
              if (
                inv_item_payment_details[element.value] != "" &&
                typeof inv_item_payment_details[element.value] !== "undefined"
              ) {
                element.due_amount =
                  parseFloat(element.due_amount) +
                  parseFloat(
                    inv_item_payment_details[element.value].pymnt_applied_amount
                  ) +
                  parseFloat(
                    inv_item_payment_details[element.value].withheld_amount
                  );
                element.paid_amount = parseFloat(
                  inv_item_payment_details[element.value].pymnt_applied_amount
                );
                element.withheld_amount = parseFloat(
                  inv_item_payment_details[element.value].withheld_amount
                );
              }
            });
            this.check_for_customer = false;
          });
        this.field.tds_tax_account = this.list.data.header_details.gl_acc_id;
        this.cus_id = this.list.data.header_details.cus_name;
      }
      this.currency_symbol = this.getDetails(
        this.$AppDetails.currency_details,
        this.field.cus_currency || this.$AppDetails.organization.org_currency,
        "currency_symbol"
      );
    },
    createFreshEventObject() {
      // empty details for header
      return {
        type: "payment_received",
        suffix: "",
        prefix: "",
        code_id: "",
        pymnt_no: "",
        cus_id: "",
        pymnt_date: this.formatDate(new Date()),
        pymnt_mthd: "",
        pymnt_type: "",
        ref_no: "",
        tns_no: "",
        received_amount: "0.00",
        bank_charges: "0.00",
        notes: "",
        deposit_mthd: "",
        used_amount: "0.00",
        pymnt_desc_changed: false,
        refund_amount: "0.00",
        excess_amount: "0.00",
        full: "0",
        is_export: 1,
        cus_currency: "",
        currency_code: this.orgCurrency,
        is_tax_deducted: 0,
        withheld_amount: "0.00",
        cus_inv_notes: "",
        unit_currency_value: 1,
        tds_tax_account: ""
      };
    }
  },
  updated: function() {
    this.$nextTick(() => {
      this.update_price = true;
    });
  },
  watch: {
    total: {
      deep: true,
      handler: function(val) {
        this.field.used_amount = val.total_paid_amount;
        this.field.excess_amount = val.excess_amount;
        this.field.withheld_amount = val.total_withheld_amount;
      }
    },
    cus_id(val) {
      if (val != "" && val.length > 2) {
        var data = {
          search_value: val,
          search_column: this.search_column
        };
        this.$store
          .dispatch("general/fetchCustomerAdvanceSearchData", data)
          .then(() => {
            this.customers = this.customer_filter_list;
          });
      }
    }
  },
  async created() {
    this.field.exchange_rate_status = this.org_details.exchange_rate_status;
    this.field.pymnt_desc_changed = 0;
    this.field.code_id = this.details.active_code_id.code_id;
    this.field.suffix = this.details.active_code_id.suffix;
    this.field.prefix = this.details.active_code_id.prefix;
    this.field.cus_inv_notes = this.pymnt_settings_details.cus_inv_notes;
    this.field.pymnt_no =
      this.details.active_code_id.prefix + this.details.active_code_id.suffix;
    for (var i = 0; i < this.pymnt_settings_details.custom_field.length; i++) {
      if (
        this.pymnt_settings_details.custom_field[i].status == 1 &&
        this.pymnt_settings_details.custom_field[i].permissions == "write"
      ) {
        this.$set(
          this.field,
          this.pymnt_settings_details.custom_field[i].field_name,
          this.pymnt_settings_details.custom_field[i].default_value
        );
      }
    }
    if (this.page == "update") {
      this.currency_details = {};
      document.title = getPageTitle(
        this.list.data.header_details.pymnt_no + " | " + this.$route.meta.title
      );
      await this.updateFields();
    } else {
      this.currency_symbol = this.orgCurrencySymbol;
    }
    //  to watch any updates in details data
    await this.$watch(
      "field",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
    if (this.$route.query.customer_id) {
      this.field.cus_id = this.$route.query.customer_id;
      this.$refs.cus_name_typeahead.inputValue = this.customer_data.cus_display_name;
      this.update_price = await true;

      await this.checkpos({
        value: this.customer_data.cus_id,
        currency: this.customer_data.cus_currency,
        pos: this.customer_data.place_of_supply
      });
    }
  },
  computed: {
    received_amount() {
      return this.field.received_amount;
    },
    //  calucation total calculation
    total() {
      var received_amount =
        this.field.received_amount != "undefined" &&
        this.field.received_amount != "" &&
        !isNaN(this.field.received_amount)
          ? parseFloat(this.field.received_amount)
          : 0;
      var refund_amount =
        this.field.refund_amount != "undefined" &&
        this.field.refund_amount != "" &&
        !isNaN(this.field.refund_amount)
          ? parseFloat(this.field.refund_amount)
          : 0;
      var total_due_amount = parseFloat(0);
      var total_withheld_amount = parseFloat(0);
      var total_paid_amount = this.items.reduce((total, value) => {
        total_due_amount += parseFloat(value.due_amount);
        if (this.field.is_tax_deducted == 1) {
          total_withheld_amount += parseFloat(value.withheld_amount || 0);
        }
        return !isNaN(parseFloat(value.paid_amount))
          ? total + parseFloat(value.paid_amount)
          : parseFloat(total);
      }, 0);
      var excess_amount = received_amount - (refund_amount + total_paid_amount);
      var data = {
        total_due_amount: total_due_amount.toFixed(2),
        excess_amount: excess_amount.toFixed(2),
        total_paid_amount: total_paid_amount.toFixed(2),
        total_withheld_amount: total_withheld_amount.toFixed(2)
      };
      return data;
    },
    ...mapState({
      customer_filter_list: state => state.general.customer_filter_list,
      details: state => state.payment.details,
      message: state => state.payment.message,
      list: state => state.payment.list,
      exchange_rate_message: state => state.currency.message,
      exchange_rate_type: state => state.currency.type,
      customer_data: state => state.customer.listView.main_detail
    }),
    currency_details: {
      get() {
        return this.$store.state.customer.currency_details;
      },
      set(val) {
        this.$store.state.customer.currency_details = val;
      }
    },
    ...mapGetters([
      "orgCurrencySymbol",
      "pymnt_settings_details",
      "orgCurrency",
      "org_details",
      "org_currency_id"
    ]),
    // mix this into the outer object with the object spread operator
    customer_invoice_details: {
      get() {
        return this.$store.state.general.customer_invoice_details;
      },
      set(val) {
        this.$store.state.general.customer_invoice_details = val;
      }
    }
  }
};
</script>
<style scoped>
.form-mask {
  pointer-events: none;
  opacity: 0.2;
}
.create-cus {
  margin-right: 20px !important;
  height: 29px;
  margin-top: 0px !important;
}
.customer_search {
  width: 657px;
}
</style>
